// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';
import { Card, color } from '@kintent/glide';

export const LeftPanel = styled(Card)`
  grid-area: left-panel;

  background-color: white;
  border-radius: 16px;

  padding: 24px;

  & .notification-group-type-container {
    padding-bottom: 32px;

    p {
      padding: 8px;
    }

    a {
      display: block;
      cursor: pointer;

      padding: 8px;
      border-radius: 8px;

      text-decoration: none;

      &.active {
        background: ${({ theme }) => color(theme.colorV2.system.gray, 50)};
      }
    }

    ul {
      list-style: none;

      li {
        padding-top: 8px;
        padding-bottom: 8px;
      }

      li:last-of-type {
        padding-bottom: 0;
      }
    }
  }

  & .notification-group-type-container:last-of-type {
    padding-bottom: 0;
  }
`;
